import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { Spinner as l } from "./Spinner.js";
import { Typography as t } from "../Typography/index.js";
const o = () => /* @__PURE__ */ e("div", { className: "fixed top-0 left-0 w-full h-full bg-alley-dark-new flex items-center justify-center", children: /* @__PURE__ */ r("div", { className: "flex flex-col items-center", children: [
  /* @__PURE__ */ e(t, { variant: "titleS", className: "mb-4 text-center", children: "Loading..." }),
  /* @__PURE__ */ e(l, {})
] }) });
export {
  o as FullPageLoader
};
